module.exports = __webpack_public_path__ + "static/media/quienes_somos.23d859e6.jpg";